import React from 'react'

import axios from 'axios'

import { api } from '../api'

/**
 * Le dashboard n'avait pas d'écran de connexion : il comptait sur une session
 * déjà ouverte sur www.fishfriender.com, ouverte ailleurs. La session vit
 * désormais sur l'hôte de l'API, où le back-office se connecte aussi, donc
 * elle s'ouvre ici.
 */
export function Login({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [username, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [pending, setPending] = React.useState(false)
  const [error, setError] = React.useState<string>()

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setPending(true)
    setError(undefined)
    try {
      await api.login({ username, password })
      onLoggedIn()
    } catch (err) {
      // 401 couvre les deux refus que la stratégie `admins` ne distingue pas :
      // identifiants faux, et compte sans rôle de back-office.
      setError(
        axios.isAxiosError(err) && err.response?.status === 401
          ? 'Identifiants invalides, ou ce compte n’a pas accès au support.'
          : 'La connexion a échoué. Réessayez.',
      )
      setPending(false)
    }
  }

  return (
    <div className="hero is-fullheight">
      <div className="hero-body">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-4-desktop is-6-tablet">
              <form className="box" onSubmit={submit}>
                <h1 className="title is-5">FF Support</h1>
                <div className="field">
                  <label className="label" htmlFor="login-username">
                    Identifiant
                  </label>
                  <div className="control">
                    <input
                      id="login-username"
                      className="input"
                      type="text"
                      autoComplete="username"
                      autoFocus
                      value={username}
                      onChange={(event) => setUsername(event.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label" htmlFor="login-password">
                    Mot de passe
                  </label>
                  <div className="control">
                    <input
                      id="login-password"
                      className="input"
                      type="password"
                      autoComplete="current-password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                    />
                  </div>
                </div>
                {!!error && <p className="help is-danger">{error}</p>}
                <div className="field mt-4">
                  <button
                    type="submit"
                    className={`button is-primary is-fullwidth ${
                      pending ? 'is-loading' : ''
                    }`}
                    disabled={pending || !username || !password}>
                    Se connecter
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
